"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
const useEventListener_1 = require("./useEventListener");
function useOnClickOutside(ref, handler, eventType = 'mousedown', eventListenerOptions = {}) {
    (0, useEventListener_1.useEventListener)(eventType, event => {
        const target = event.target;
        // Do nothing if the target is not connected element with document
        if (!target || !target.isConnected) {
            return;
        }
        const isOutside = Array.isArray(ref)
            ? ref
                .filter(r => Boolean(r.current))
                .every(r => r.current && !r.current.contains(target))
            : ref.current && !ref.current.contains(target);
        if (isOutside) {
            handler(event);
        }
    }, undefined, eventListenerOptions);
}
exports.useOnClickOutside = useOnClickOutside;
